import { Box, Icon, List, Paragraph, Text } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

import { StyledHR } from '../../StyledComponents';

const RentGuaranteeSelectionsContent = ({
  premium,
  monthlyRent,
  landlordReceiptAmount,
  isSecurityDepositWaived,
  securityDepositAmount,
  isApplicationsAccepted,
}) => {
  const infoSections = [
    {
      section: 'Rental Protection premium',
      title: `${Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumSignificantDigits: 2,
      }).format(premium)} per month*`,
      description: `
            i.e. If the tenant pays ${Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumSignificantDigits: 5,
            }).format(
              monthlyRent,
            )} in rent to your bank account, the premium will automatically be paid and you’ll receive ${Intl.NumberFormat(
              'en-US',
              {
                style: 'currency',
                currency: 'USD',
                maximumSignificantDigits: 5,
              },
            ).format(landlordReceiptAmount)} in your bank account.
           `,
    },
    {
      section: 'Security deposit',
      title: isSecurityDepositWaived
        ? '$0'
        : Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumSignificantDigits: 5,
          }).format(securityDepositAmount),
      description: isSecurityDepositWaived
        ? 'Your listing will show that you do not require a security deposit.'
        : 'Any claim for loss covered under Rental Protection will be reduced by this amount.',
    },
    {
      section: 'Online tools',
      title: 'You agreed to use Zillow tools to:',
      description: (
        <List.Root appearance="number" css={{ fontSize: 'body-xs', paddingLeft: '400' }}>
          <List.Item css={{ paddingBlock: '0' }}>
            <Box css={{ display: 'flex', alignItems: 'center' }}>
              Accept applications{' '}
              {isApplicationsAccepted && (
                <Icon size="sm" css={{ marginLeft: '100', color: 'green' }}>
                  <IconCheckmarkCircleFilled />
                </Icon>
              )}
            </Box>
          </List.Item>
          <List.Item css={{ paddingBlock: '0' }}>Upload or create a lease</List.Item>
          <List.Item css={{ paddingBlock: '0' }}>Set up payments</List.Item>
        </List.Root>
      ),
    },
  ];

  return (
    <>
      {infoSections.map((section) => (
        <Box
          css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)' }}
          key={section.section}
          data-test={section.section}
        >
          <Box css={{ gridColumnEnd: 'span 12' }}>
            <StyledHR color="gray300" />
          </Box>
          <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 6' } }}>
            <Text>{section.section}</Text>
          </Box>
          <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 6' } }}>
            <Paragraph textStyle="body-bold">{section.title}</Paragraph>
            <Text textStyle="body-xs">{section.description}</Text>
          </Box>
        </Box>
      ))}
      <StyledHR color="gray300" />
    </>
  );
};

export default RentGuaranteeSelectionsContent;
